/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/no-inferrable-types */

/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */

export class GameConstants {
	public static nameMinLen: number = 4;
	public static nameMaxLen: number = 25;
	public static passwordMinSize: number = 4;
}
